module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Light-5edbd86645c9052f7b7bd479496a6ff7.woff2";